// extracted by mini-css-extract-plugin
module.exports = {"baseBlock":"BVkl","outlined":"BVkn","header":"BVap","chevron":"BVkp","headerDefaultColor":"BVkr","link":"BVch"};